import { useMutation } from '@tanstack/react-query';

import { submitCollectionWish } from '@/services/collectionWishes';

export function useCollectionWish() {
  return useMutation({ mutationFn: submitCollectionWish });
}
